import React, { useRef, useMemo, useEffect, useCallback, useState, } from 'react';
import { DropdownStateContext, } from './DropdownStateContext';
import { useOnOutsideClick } from '../../utils/hooks/useOnOutsideClick';
import { useDropdownState } from '../hooks/useDropdownState';
// This component manages your dropdown state (open/close) and
// attaches some event handlers. Use if you need to build something custom
var DropdownStateManager = function (_a) {
    var children = _a.children, onOpen = _a.onOpen, onClose = _a.onClose, onToggle = _a.onToggle, disabled = _a.disabled;
    // state purely used to trigger effect re-run when toggle node changes
    var _b = useState(null), toggleNode = _b[0], setToggleNode = _b[1];
    var toggleRef = useRef(null);
    var menuRef = useRef(null);
    var _c = useDropdownState(menuRef, toggleRef, {
        disabled: disabled,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
    }), isOpen = _c.isOpen, openDropdown = _c.openDropdown, closeDropdown = _c.closeDropdown, toggleDropdown = _c.toggleDropdown;
    useOnOutsideClick([toggleRef, menuRef], closeDropdown);
    var onKeyDown = useCallback(function (e) {
        if (!toggleRef.current ||
            !toggleRef.current.contains(document.activeElement)) {
            return;
        }
        switch (e.key) {
            case 'Spacebar':
            case ' ':
            case 'Enter':
                toggleDropdown();
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                if (!isOpen) {
                    openDropdown();
                    e.preventDefault();
                }
                break;
            case 'Escape':
            case 'Tab':
                closeDropdown();
                break;
            default:
        }
    }, [closeDropdown, isOpen, openDropdown, toggleDropdown]);
    var context = useMemo(function () { return ({
        isOpen: isOpen,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown,
        setToggleRef: function (node) {
            toggleRef.current = node;
            setToggleNode(node);
        },
        setMenuRef: function (node) { return (menuRef.current = node); },
    }); }, [isOpen, openDropdown, closeDropdown, toggleDropdown]);
    // attach toggle events
    useEffect(function () {
        var toggle = toggleRef.current;
        if (!toggle || disabled) {
            return;
        }
        toggle.addEventListener('click', toggleDropdown);
        toggle.addEventListener('keydown', onKeyDown);
        return function () {
            toggle.removeEventListener('click', toggleDropdown);
            toggle.removeEventListener('keydown', onKeyDown);
        };
    }, [toggleDropdown, disabled, onKeyDown, toggleNode]);
    return (React.createElement(DropdownStateContext.Provider, { value: context }, children));
};
DropdownStateManager.displayName = 'DropdownStateManager';
export default DropdownStateManager;
//# sourceMappingURL=DropdownStateManager.js.map